import { apiClient } from "./client";
import { setAuthToken } from "../auth/authStorage";

export function getGoogleAuthErrorMessage(error) {
  const status = error.response?.status;
  if (status === 400) return "Google sign-in could not be configured for this account.";
  if (status === 401) return "Google sign-in expired or was rejected. Please try again.";
  if (status === 429) return "Too many Google sign-in attempts. Please wait and try again.";
  if (status === 503) return "Google sign-in is not configured on the server.";
  return "Google sign-in failed. Please try again.";
}

export async function completeGoogleSignIn({ credentialResponse, persistent, setUser, navigate, legalVersions }) {
  if (!credentialResponse?.credential) throw new Error("MISSING_GOOGLE_CREDENTIAL");
  const response = await apiClient.post("/auth/google", {
    credential: credentialResponse.credential,
    ...(legalVersions || {})
  }, { skipAuth: true });
  const userData = response.data;
  setAuthToken(userData.token, { persistent });
  setUser({
    ...userData,
    profile_image: userData.profile_image || userData.google_picture_url || null
  });
  navigate("/");
  return userData;
}
